export enum BracketWinnerEnum {
  PARTICIPANT_ONE = "PARTICIPANT_ONE",
  PARTICIPANT_TWO = "PARTICIPANT_TWO",
  DRAW = "DRAW",
}
